<script setup lang="ts">
import { useRouter } from 'vue-router';
import { ArrowLeft } from '@lucide/vue';
import type { Partner } from '@evolfin/shared';
import { useAvvisi } from '@/composables/useAvvisi';
import { useInvalidation } from '@/composables/useInvalidation';
import FormPartner from '../components/FormPartner.vue';

definePage({ meta: { titolo: 'Nuovo partner', privilegi: ['can_create_partner'] } });

const router = useRouter();
const avvisi = useAvvisi();
// L'elenco da cui si è arrivati non sa ancora della riga nuova.
const invalidate = useInvalidation('partner');

function salvato(partner: Partner): void {
  void invalidate();
  avvisi.successo('Partner creato');
  void router.push(`/partner/${partner.id}`);
}
</script>

<template>
  <div class="mx-auto flex w-full max-w-5xl flex-col gap-6">
    <div>
      <button
        type="button"
        class="flex w-fit items-center gap-1.5 text-[13px] text-ink-secondary transition-colors hover:text-ink"
        @click="router.push('/partner')"
      >
        <ArrowLeft :size="15" :stroke-width="1.9" /> Partner
      </button>
      <h1 class="mt-3 font-display text-[28px] leading-tight font-semibold">Nuovo partner</h1>
      <p class="mt-1 text-[13px] text-ink-secondary">
        Registra l'anagrafica dell'azienda. Le persone di riferimento si aggiungono poi dalla scheda
        del partner.
      </p>
    </div>

    <FormPartner @salvato="salvato" @annulla="router.push('/partner')" />
  </div>
</template>
